export const CookieService = {
    // load the cookies
    loadCookieData(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    // returns the cookies as a parsed object
    getCookie (name) {
        let cookie = this.loadCookieData(name);
        if (cookie) {
            cookie = JSON.parse(cookie)
            return cookie
        }
    },

    /**
     * Stores the cookie
     * @param name cookie name
     * @param data cookie data
     * @param expireDays days to store the cookie
     */
    storeCookie (name, data, expireDays) {
        const cookie = JSON.stringify(data)
        const d = new Date();
        d.setTime(d.getTime() + (expireDays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = name + "=" + cookie + ";expires=" + expires + ";path=/"
    },

    clearCookie (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
}
